import { isNotEmpty, useForm } from '@mantine/form'
import {
  selectCurrentOrganization,
  selectOrganizations,
} from '@v2/domains/user/selectors/user.selectors'
import { useAppSelector } from '@v2/store/hooks'

import { useChangeOrganizationProcess } from './useChangeOrganizationProcess.hook'

export const useSwitchOrganization = (
  personOrganizations: any,
  personId: string,
) => {
  const currentOrganization = useAppSelector(selectCurrentOrganization)
  const newOrganizationToSwitch = useAppSelector(selectOrganizations)
    .filter((organization) => personOrganizations.includes(organization.name))
    .filter((organization) => organization.id !== currentOrganization.id)

  const form = useForm<{ newOrganization: string }>({
    initialValues: {
      newOrganization:
        newOrganizationToSwitch.length === 1
          ? newOrganizationToSwitch[0].id
          : '',
    },
    mode: 'uncontrolled',
    validate: {
      newOrganization: isNotEmpty('Organization is required!'),
    },
  })

  const { handleChangeOrganization, isChanging } =
    useChangeOrganizationProcess()

  const newListOrganizations = newOrganizationToSwitch.map((org) => ({
    value: org.id,
    label: org.name,
  }))

  const onSubmit = () => {
    form.onSubmit(async (values) => {
      const organization = newOrganizationToSwitch.find(
        (org) => org.id === values.newOrganization,
      )

      if (organization) {
        const organizationId = organization.id
        const membershipId = organization.memberships?.at(0)?.id ?? ''
        handleChangeOrganization(organizationId, membershipId, personId)
      }
    })()
  }

  return {
    newListOrganizations,
    isChanging,
    form,
    onSubmit,
  }
}
